import { makeStyles } from '@material-ui/core/styles';
export const useRegisterSupportStyles = makeStyles(theme => ({
    successWrapper: {
        padding: '0px',
        maxHeight: '425px',
        '@media(max-width: 599px)': {
            // maxWidth: '344px',

            maxHeight: '100%',
            // marginLeft: '16px',
        },
    },

    successMain: {
        marginLeft: 'auto',
        marginRight: 'auto',
        // marginTop: '140px',
        // padding: '32px',
        maxWidth: '634px',

        '@media(max-width: 1019px)': {
            padding: '0 99px',
            maxWidth: '858px',
        },
        '@media(max-width: 599px)': {
            // maxWidth: '344px',
            marginTop: '8px',
            padding: '0 8px',
            height: '100%',
            maxWidth: '344px',
            maxHeight: '100%',
            // marginLeft: '16px',
        },
    },

    successMainWrapper: {
        background: 'white',
    },

    successMainModal: {
        // background: theme.palette.primary.gray550,
        backdropFilter: 'blur(10px)',
    },

    successMainBackDrop: {},

    successMainContent: {
        border: 'none',
        borderRadius: '10px',

        '@media(max-width: 599px)': {
            paddingTop: '32px',
            height: '100%',
        },

        '@media (min-width: 600px) and (max-width: 1019px)': {
            width: '560px',
        },
    },

    successModalBody: {
        minHeight: '425px',
        padding: '24px 32px',

        '@media(max-width: 599px)': {
            minHeight: '100%',
            padding: '16px 16px 16px 16px',
        },
    },

    registerTitleContainer: {
        paddingTop: '31px',
        textAlign: 'center',

        '@media (max-width: 599px)': {
            paddingTop: '24px',
        },
    },

    registerTitle: {
        fontFamily: theme.typography.h2.fontFamily,
        fontStyle: 'normal',
        fontWeight: theme.typography.h2.fontWeight,
        fontSize: theme.typography.h2.fontSize,
        lineHeight: theme.typography.h2.lineHeight,
        color: theme.palette.primary.heather,
        '@media (max-width: 599px)': {
            fontSize: '20px',
            lineHeight: '24px',
        },

        '@media (min-width: 0px) and (max-width: 1019px)': {
            //  display: 'none',
            fontSize:'20px',

        },
    },
    registerTechTitle: {
        fontFamily: theme.typography.h2.fontFamily,
        fontStyle: 'normal',
        fontWeight: theme.typography.h2.fontWeight,
        fontSize: theme.typography.h1.fontSize,
        lineHeight: theme.typography.h2.lineHeight,
        color: theme.palette.primary.heather,

        '@media (max-width: 599px)': {
            fontSize: theme.typography.h2.fontSize,
            lineHeight: theme.typography.h2.lineHeight,
        },
    },

    successBody: {
        // width: '60%',
        margin: '0 auto',
        padding: '32px',
        // paddingTop: '0.2rem',
        textAlign: '-webkit-center',
        // position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',

        '@media (max-width: 599px)': {
            width: '100%',
            paddingTop: '0px',
            justifyContent: 'center',
        },

        '@media (min-width: 600px) and (max-width:1019px)': {
            // width: '65%',
            paddingTop: '1rem',
            justifyContent: 'center',
        },
    },

    tickWrapper: {
        maxWidth: '100%',
    },

    tickCircle: {},

    tick: {
        // width: '62.5px',
        paddingTop: '6px',
        '@media (max-width: 599px)': {
            width: '58.5px',
        },
    },
    tech: {
        width: '83px',
    },

    newsTextWrapper: {
        // marginTop: '1rem',
        // marginBottom: '2rem',

        '@media (max-width: 599px)': {
            // marginTop: '16px',
            marginBottom: '32px',
        },
    },

    newsText: {
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: '14px',
        lineHeight: '24px',
        color: theme.palette.primary.heather,
        marginTop: '22px',
        '@media (min-width: 0px) and (max-width: 1019px)': {
            fontSize: '14px',
            fontWeight: '300',
        },
        '@media (min-width: 600px) and (max-width: 1019px)': {
            fontSize: theme.typography.h5.fontSize,
            // fontWeight: '700',
        },
    },
    newsTextBold: {
        fontFamily: theme.typography.subtitle3.fontFamily,

        fontWeight: theme.typography.subtitle3.fontWeight,
        fontSize: '14px',
        lineHeight: '24px',
        color: theme.palette.primary.heather,
        marginTop: '22px',
        '@media (min-width: 0px) and (max-width: 1019px)': {
            fontSize: '14px',
            fontWeight: '700',
        },
        '@media (min-width: 600px) and (max-width: 1019px)': {
            fontSize: theme.typography.h5.fontSize,
            // fontWeight: '700',
        },
    },
    newsTexts: {
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: '14px',
        lineHeight: '24px',
        color: theme.palette.primary.heather,
        marginTop: '26px',
        '@media (min-width: 0px) and (max-width: 1019px)': {
            fontSize: '14px',
            fontWeight: '300',
        },
        '@media (min-width: 600px) and (max-width: 1019px)': {
            fontSize: theme.typography.h5.fontSize,
            // fontWeight: '700',
        },
    },

    successFooter: {
        minHeight: '80px',
        // marginTop: '3.5rem',
        // marginBottom: '3.6rem',

        '@media (max-width: 599px)': {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            marginTop: '144px',
            paddingBottom: '33px',
        },
        '@media (min-width: 600px) and (max-width: 1019px)': {
            // marginTop: '3.5rem',
            // paddingBottom: '3.6rem',
        },

        '& .footer-cta': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto',
            width: '184px',
            borderRadius: '6px',
            fontFamily: theme.typography.subtitle1.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.subtitle1.fontWeight,
            fontSize: theme.typography.subtitle1.fontSize,
            lineHeight: theme.typography.subtitle1.lineHeight,
            textAlign: 'center',

            '@media (min-width:0px) and (max-width: 1019px)': {
                width: '296px',
            },
        },

        '& .primary-cta': {
            minHeight: '41px',
            borderColor: 'transparent',
            color: theme.palette.primary.white,
            background: theme.palette.primary.sunset,

            '&:hover': {
                background: theme.palette.primary.sunset30,
            },
        },

        '& .secondary-cta': {
            minHeight: '41px',
            marginTop: '8px',
            color: '#DD1D77',
            backgroundColor: 'transparent',
            borderColor: '#DD1D77',
        },
    },

    primaryCta: {
        minHeight: '42px',
        marginBottom: '3px',
        borderColor: 'transparent',
    },

    secondaryCta: {
        minHeight: '41px',
        color: theme.palette.primary.sunset,
    },
    registerLine: {
        border: `1px solid ${theme.palette.primary.borderColor}`,
        borderTopWidth: '0px',
        marginTop: '6px',

        '@media(max-width: 599px)': {
            marginTop: '4px',
        },
    },
}));
